import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38">
      <path
        d="M19.306 1.449c9.919 0 17.96 8.04 17.96 17.96 0 9.918-8.041 17.958-17.96 17.958-9.918 0-17.96-8.04-17.96-17.959 0-9.918 8.042-17.959 17.96-17.959ZM6.727 20.425l.246 1.359a11.793 11.793 0 0 0 3.278 6.266 11.92 11.92 0 0 0 5.71 3.168l-.56-5.554a6.806 6.806 0 0 1-3.436-4.592l-5.238-.647Zm24.156 0-5.237.647a6.806 6.806 0 0 1-3.437 4.592l-.56 5.554a11.92 11.92 0 0 0 5.711-3.168c1.713-1.714 2.918-4.031 3.35-6.417l.173-1.207ZM18.832 7.274c-5.261 0-9.74 3.35-11.42 8.032l6.015-.798a7.178 7.178 0 0 1 5.363-2.276 7.179 7.179 0 0 1 5.363 2.275l6.091.776c-1.687-4.67-6.16-8.009-11.412-8.009Z"
        stroke="#000"
        fill="none"
      />
    </svg>
  );
};

export default Icon;
